export default __webpack_public_path__ + "locales/zh-CN/Common.json?hash=fc9940684d67805cc537a6758d01bbd5";